var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"interaction"},[_c('div',{staticClass:"apparel"},[_c('div',{staticClass:"center"},[_c('div',{staticClass:"exchange"},[_c('h2',[_vm._v("人机交互")]),_c('h2',[_vm._v("俱身智能")]),_c('p',[_vm._v("仿生机器人与智能穿戴结合的情感交互")])])])])])
}]

export { render, staticRenderFns }